import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <>
      <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18.2703 18.4054H5.72973C4.77449 18.4054 4 17.6309 4 16.6757V6.72973C4 5.77449 4.77449 5 5.72973 5H18.2703C19.2255 5 20 5.77449 20 6.72973V16.6757C20 17.6309 19.2255 18.4054 18.2703 18.4054Z"
          stroke="#818C99"
          strokeWidth="1.4"
          strokeMiterlimit="10"
        />
        <path
          d="M10.6648 13.5586L9.04318 9.45045C8.96145 9.24375 8.7621 9.1084 8.54026 9.1084C8.31842 9.1084 8.11907 9.24375 8.03734 9.45045L6.41572 13.5586C6.30631 13.8362 6.44253 14.1501 6.72015 14.26C6.99864 14.3698 7.31172 14.2332 7.42156 13.9555L7.58545 13.5408H9.49594L9.65983 13.9555C9.74286 14.1683 9.94653 14.2976 10.1623 14.2976C10.228 14.2976 10.2955 14.2855 10.3604 14.2595C10.638 14.1501 10.7742 13.8362 10.6648 13.5586ZM8.01183 12.4597L8.54026 11.1209L9.06869 12.4597H8.01183Z"
          fill="#818C99"
        />
        <path
          d="M16.8648 14.2976C16.5664 14.2976 16.3242 14.0554 16.3242 13.757V9.64894C16.3242 9.35056 16.5664 9.1084 16.8648 9.1084C17.1631 9.1084 17.4053 9.35056 17.4053 9.64894V13.757C17.4053 14.0554 17.1631 14.2976 16.8648 14.2976Z"
          fill="#818C99"
        />
        <path
          d="M13.5133 9.1084H12.1079C11.8095 9.1084 11.5674 9.35056 11.5674 9.64894V13.757C11.5674 14.0554 11.8095 14.2976 12.1079 14.2976C12.4063 14.2976 12.6485 14.0554 12.6485 13.757V13.0003H13.5133C14.5862 13.0003 15.4593 12.1272 15.4593 11.0543C15.4593 9.98148 14.5862 9.1084 13.5133 9.1084ZM13.5133 11.9192H12.6485V10.1895H13.5133C13.9903 10.1895 14.3782 10.5774 14.3782 11.0543C14.3782 11.5313 13.9903 11.9192 13.5133 11.9192Z"
          fill="#818C99"
        />
      </svg>
    </>
  );
};
